//TODO : Refactor after ai
import type { HTMLAttributes, ReactNode } from "react";
import type { ToneColor } from "../types";
import { toneOf } from "./tone";

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  children?: ReactNode;
  color?: ToneColor;
  variant?: "light" | "filled" | "outline" | "ghost";
  size?: "sm" | "md" | "lg";
  dot?: boolean;
  icon?: ReactNode;
  radius?: "pill" | "rounded";
}

/** Pill label badge — 7 colours x 4 styles x 3 sizes, optional leading dot. */
export function Badge({
  children,
  color = "neutral",
  variant = "light",
  size = "sm",
  dot = false,
  icon,
  radius = "pill",
  className = "",
  ...rest
}: BadgeProps) {
  const t = toneOf(color);
  const style =
    variant === "filled"
      ? { background: t.solid, color: "#fff" }
      : variant === "outline"
        ? {
            background: "var(--bg-primary)",
            color: t.fg,
            boxShadow: `inset 0 0 0 1px ${t.solid}`,
          }
        : variant === "ghost"
          ? { background: "transparent", color: t.fg }
          : { background: t.bg, color: t.fg };

  return (
    <span
      className={`bui-badge ${className}`}
      data-size={size}
      data-radius={radius === "rounded" ? "rounded" : undefined}
      style={style}
      {...rest}
    >
      {dot && (
        <span
          className="bui-badge__dot"
          style={{ background: variant === "filled" ? "#fff" : t.solid }}
        />
      )}
      {icon}
      {children}
    </span>
  );
}
